import React from 'react'
import { PersonItem } from './personItem'
import { personList } from './mock'

export const Persons = () => {
    return (
        <div className="persons_component">
            <ul>
                {personList.map(item=>(
                    <PersonItem item={item} />
                ))}
            </ul>
        </div>
    )
}